// Phone OTP via Message Central (Supabase Edge Functions otp-send / otp-verify).
// Message Central texts + checks the code; otp-verify returns a normal Supabase
// session, which we install with setSession. Codes expire fast (~60s), so pages
// verify as soon as the code is entered, before asking for a new password.
import { supabase } from './supabase';

async function invoke(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });
  if (error) {
    let message = error.message;
    try {
      const j = await error.context?.json?.();
      if (j?.message) message = j.message;
    } catch { /* keep generic message */ }
    throw new Error(message);
  }
  return data;
}

// Tags requests in otp_requests.app for the IT Tools OTP tab.
const APP = 'website';

let lastVerified = null;

export async function requestOtp(phoneE164, createUser) {
  await invoke('otp-send', { phone: phoneE164, create_user: createUser, app: APP });
}

export async function verifyOtpCode(phoneE164, code, createUser) {
  const data = await invoke('otp-verify', { phone: phoneE164, code, create_user: createUser });
  const { data: set, error } = await supabase.auth.setSession({
    access_token: data.session.access_token,
    refresh_token: data.session.refresh_token,
  });
  if (error) throw error;
  lastVerified = { phone: phoneE164, at: Date.now() };
  return set; // { session, user }
}

// True when this phone was verified on this page within the last 10 min and we
// are still signed in as it — lets reset/signup skip a second code check.
export async function isFreshlyVerified(phoneE164) {
  if (!lastVerified || lastVerified.phone !== phoneE164 || Date.now() - lastVerified.at > 10 * 60_000) return false;
  const { data } = await supabase.auth.getSession();
  return data.session?.user?.phone === phoneE164.replace(/\D/g, '');
}
